export default __webpack_public_path__ + "static/media/SearchIconWhite.e3009018.svg";